<!--office组件，展示ppt,word等文件-->
<template>
	<div class="officeBar">
        <div class="more">
             <i v-show="this.showbar"  @click="orientate($event)" class="fa fa-expand"></i>
             <i v-show="!this.showbar"  @click="tofix($event)" class="fa fa-compress"></i>
        </div>
		<iframe id="ppt"  ref="ppt">
		</iframe>
	</div>
</template>
<script>
import $ from 'jquery';
import { eventBus } from '@/assets/js/eventBus';
export default {
    data(){
        return {
            showbar:true,
            //type:'',
        };
    },
    mounted() {
        const that = this;
        eventBus.$on("pptUrl",(val) => {
            //this.$refs.ppt.src ="http://ow365.cn/?i=18551&furl="+val.url; 
            this.$refs.ppt.src ="http://ow365.cn/?i=18551&readpage=QPvhSIo0iUMeMcuV5xv72joJFY9DhR6C&furl=" +val.url;
        });
        $(".officeBar").css("padding-top",'5.1rem');
        $('iframe').addClass("PPtStyle");
        $("#ppt").css("height",screen.width/1.78);
    },
    methods: {
        //横屏
        orientate(event) {
            event.cancelBubble = true;
            this.showbar = false;
            var width = screen.width;//获取客户端宽度
            var height = screen.height;//获取客户端高度
            var $print = $(".officeBar");//video标签上层div
            var $iframe = $("#ppt");
            $('iframe').removeClass("PPtStyle");
            $('#tsd-top').removeClass('tsd-top');
            //旋转之后高度变宽度，宽度变高度
            $print.width(height);
            $print.height(width-78);
            $iframe.height(width);
            $iframe.width(height);
            $(".more").css("right",'6%');
            $(".officeBar").css("padding-top",'0')
            $print.css("top", (height-width)/2);//设置video标签纵坐标
            $print.css("left", 0-(height-width+2)/2);//video标签设置横坐标
            $print.css("transform", "rotate(90deg)");//旋转90度
            $print.css("transform-origin", "50% 50%");
            // //设置定位与优先级，使video标签覆盖其他内容
            $print.css("z-index", "999");
            $print.css("position", "fixed");
        },
        //竖屏，将所有css恢复到最初
        tofix(event) {
            event.cancelBubble = true;
            this.showbar = true;
            var width = screen.width;//获取客户端宽度
            var height = screen.height;//获取客户端高度
            var $print = $(".officeBar");
            var $iframe = $("#ppt");
            $('iframe').addClass("PPtStyle");
            $('#tsd-top').addClass('tsd-top');
            $print.css({
                width: '100%',
                height:'auto',
                transform: "none",
                "transform-origin": "50% 50%",
                position: "static",
                top: "0",
                left: "0",
                "padding-top":"5.1rem",
            });
            $iframe.css({
                width: "100%",
                height: screen.width/1.78,
            });
        },
    },
};

</script>
<style>
.more{
    padding: 1rem;
    position: absolute;
    color: #ffffff;
    right: 0.5rem;
    z-index: 9999;
    font-size: 1.5rem;
}
iframe{
    z-index:9998;
    background:black;
}
.PPtStyle{
    width:100%;
}
iframe {
    border-width:0 !important;
    border:none !important;
}
</style>

